import { render, staticRenderFns } from "./CommonLang.vue?vue&type=template&id=78e28245&scoped=true"
import script from "./CommonLang.vue?vue&type=script&lang=js"
export * from "./CommonLang.vue?vue&type=script&lang=js"
import style0 from "./CommonLang.vue?vue&type=style&index=0&id=78e28245&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e28245",
  null
  
)

export default component.exports